<template>
  <div class="container">
    <div class="title">
      <span>详细信息</span>
      <span class="back" @click="back">
        <i class="iconfont icon-fanhui"></i> 返回
      </span>
    </div>
    <div class="wrap">
      <el-row>
        <el-col
          :lg="16"
          :md="20"
          :sm="24"
          :xs="24">
          <el-form
            v-loading="loading"
            :model="form"
            :rules="rules"
            status-icon
            ref="form"
            label-width="100px"
            @submit.native.prevent>
            <el-row>
              <el-col :span='12'>
                <el-form-item label="名字" prop="name">
                  <el-input size="medium" v-model="form.player.name" placeholder="请填写姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="电话号码" prop="phone">
                  <el-input size="medium" v-model="form.player.phone" placeholder="请填写电话号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span='12'>
                <el-form-item label="公司" prop="company">
                  <el-input size="medium" v-model="form.company" placeholder="请填写公司地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="职位" prop="title">
                  <el-input size="medium" autosize v-model="form.title" placeholder="请填写个人职位"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span='12'>
                <el-form-item label="公司地址" prop="company_address">
                  <el-input size="medium" type="textarea"  v-model="form.company_address" placeholder="请填写公司地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="个人简介" prop="summary">
                  <el-input size="medium" type="textarea" v-model="form.summary" placeholder="请填写个人简介"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-row>
              <el-col :span='12'>
                <el-form-item label="编号" prop="code">
                  <el-input size="medium" v-model="form.code" placeholder="请填写销售人员编号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span='12'>
                <el-form-item label="头像" prop="image">
                  <uploader ref="uploader" v-model="form.player.head"/>
                  <el-input size="medium" v-model="form.player.head" placeholder="头像地址"></el-input>
                </el-form-item>   
              </el-col>
            </el-row>

            <el-form-item class="submit">
              <el-button @click="projectInfoVisiable=true">参与项目</el-button>
              <el-button type="primary" @click="submitForm('form')">保 存</el-button>
              <el-button @click="resetForm('form')">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="参与项目" :visible.sync="projectInfoVisiable">
      <salemans-projects v-if="projectInfoVisiable" :dataID='dataID'></salemans-projects>
    </el-dialog>
  </div>
</template>

<script>
import salesman from '../../models/salesman.js'
import Uploader from '../../../Common/components/file/uploader'
import SalemansProjects from './SalesmansProjects'

export default {
  components: {
    Uploader,
    SalemansProjects,
  },
  props: {
    dataID: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        player: {},
      },
      rules: {
      },
      projectInfoVisiable: false,
    }
  },
  methods: {
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const res = await salesman.edit(this.dataID, this.form)
            if (res.error_code === 0) {
              this.$message.success(`${res.msg}`)
              this.$emit('editClose')
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log('error submit!!')
          this.$message.error('请填写正确的信息')
          return false
        }
      })
    },
    onUploded(url) {
      this.form.head = url
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$refs.uploader.reset()
    },
    back() {
      this.$emit('editClose')
    },
  },
  async mounted() {
    this.loading = true
    this.form = await salesman.get(this.dataID) || {player:{}}

    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
    background-color: #fefefe;
  }

  .submit {
    float: left;
  }
}
</style>
